// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const CONTEST_IS_FINISHED_EXPLANATION1 = "S\u00fa\u0165a\u017e sa skon\u010dila";
export const CONTEST_IS_FINISHED_EXPLANATION2_link = "Preto sa do nej ned\u00e1 zapoji\u0165. Pozri %(link)s.";
export const COUNSELLING_ANSWERED = "Zodpovedan\u00e9";
export const POST_REMOVE_COMPLAINTS = "Zru\u0161 nahl\u00e1senie pr\u00edspevku";
export const RUNNING_CONTESTS = "prebiehaj\u00face s\u00fa\u0165a\u017ee";
export const TOPIC_MODERATOR = "Moder\u00e1tor";
